import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faArrowCircleDown, faArrowCircleUp } from '@fortawesome/free-solid-svg-icons';
import { FAQService } from "../services/faq.service";
import { GlobalSearchService } from '../services/globalsearch.service';

@Component({
  selector: 'faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FAQComponent implements OnInit {
  private faqId$: Subscription;
  handleNavigate: boolean = false;
  questionId: number = null;
  isLoading = false;
  faqsData: any;
  hotTopics: any;
  mainClass: any;
  classGroup: any;
  faqItems: any;
  selectedItems: any;
  selectedClassName='';

  constructor(private faqService: FAQService,
    library: FaIconLibrary,
    private globalSearchService: GlobalSearchService,
  ) { 
    library.addIcons(faArrowCircleDown, faArrowCircleUp);
  }

  ngOnInit(): void {
    this.faqService.loadFAQs();
    this.faqService.faqs$.subscribe((responsedata:any) => {
      if(responsedata!=null){                  
        if(responsedata.loading){
          this.isLoading = true;
        } else {
          this.isLoading = false;
          this.faqsData = responsedata["data"];
          if(this.faqsData) {
            this.hotTopics = JSON.parse(this.faqsData[0].hotTopics);
            this.mainClass = JSON.parse(this.faqsData[0].mainClass);
            this.classGroup = JSON.parse(this.faqsData[0].classGroup);
            this.faqItems = JSON.parse(this.faqsData[0].faqItems);
            if(this.faqItems.length>0){
              this.selectedItems = this.faqItems[0].b;
              this.selectedClassName = this.faqItems[0].classname;
              this.faqItems.forEach((ele,i) => {
                if(i == 0){
                  ele['isClicked'] = true;
                  ele['showTopics'] = true;
                }else{
                  ele['isClicked'] = false;
                  ele['showTopics'] = false;
                }
                if(ele.b && ele.b.length>0){
                  ele.b.forEach(element => {
                    element['isClicked'] = false;
                    if(element.c && element.c.length>0){
                      element.c.forEach(q => {
                        q['isOpen'] = false;
                      });
                    }
                  });
                }
              });
            }

            this.handleNavigate = true;
            if (this.questionId) {
              this.openQuestion(this.questionId);
              this.globalSearchService.setFaqId(null);
            }
          }
        }          
      }
    });

    this.faqId$ = this.globalSearchService.faqId$.subscribe((res: number) => {
      this.questionId = res;
      if (this.handleNavigate && res) {
        this.openQuestion(res);
        this.globalSearchService.setFaqId(null);
      }
    });
  }

  ngOnDestroy(): void {
    this.faqId$.unsubscribe();
  }

  selectGroup(groupObj){
    if(this.faqItems.length>0){
      this.faqItems.forEach(element => {
       if(element['classname'] == this.selectedClassName){
        if(element.b && element.b.length>0){
          element.b.forEach(ele => {
            if(ele['groupname'] == groupObj['groupname']){
              ele['isClicked'] = true;
            }else{
              ele['isClicked'] = false;
            }
          });
        }
       }else{
        if(element.b && element.b.length>0){
          element.b.forEach(ele => {
              ele['isClicked'] = false;
          });
        }
       }
      })
    }
  }
  selectClass(classObj){
    if(classObj){
      this.selectedItems = classObj.b;
      this.selectedClassName = classObj.classname;
      classObj['isClicked'] = true;
        this.faqItems.forEach(element => {
          if(element['classname'] !== classObj['classname']){
            element['isClicked']=false;
          }
          if(element.b && element.b.length>0){
            element.b.forEach(ele => {
                ele['isClicked'] = false;
            });
          }
        })
    }
  }

  openQuestion(id) {
    let classObj = null;
    let groupObj = null;
    this.faqItems.forEach(c => {
      if(c.b && c.b.length > 0){
        c.b.forEach(group => {
          if (group.c && group.c.length > 0) {
            group.c.forEach(question => {
              if (question.id === id) {
                question['isOpen'] = true;
                groupObj = group;
                classObj = c;
              } else {
                question['isOpen'] = false;
              }
            });
          }
        });
      }
    });

    this.selectClass(classObj);
    this.selectGroup(groupObj);
    if (groupObj) {
      this.handleClickGroup('Group' + groupObj.groupname);
    }
  }

  handleClickGroup(id) {
    const ele = document.getElementById(id);
    if (ele) {
      ele.click();
    } else {
      setTimeout(() => {
        this.handleClickGroup(id);
      }, 500);
    }
  }
}
